import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../../redux/title/title.slice';

export default function ComingSoon() {
  const mainColor = '#CC6323';
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate((prev) => !prev);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    dispatch(setPageTitle('Home'));
  }, [dispatch]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Box sx={{ textAlign: 'center', display: 'inline-block' }}>
        {/* Title */}
        <Typography variant="h2" fontWeight={800} sx={{ color: mainColor }}>
          Coming Soon
        </Typography>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          We’re building something great 🚧
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          This section is currently under construction. Please check back soon.
        </Typography>

        {/* Under Construction SVG */}
        <Box sx={{ display: 'inline-block', mt: 4 }}>
          <svg viewBox="0 0 200 200" width="220" height="220">
            <defs>
              <linearGradient id="g3" x1="0" x2="1">
                <stop offset="0%" stopColor={mainColor} stopOpacity="0.95" />
                <stop offset="100%" stopColor="#FFB89A" stopOpacity="0.9" />
              </linearGradient>
            </defs>

            {/* Ground */}
            <rect x="0" y="180" width="200" height="10" fill="#333" />

            {/* Building */}
            <rect x="120" y="90" width="45" height="90" rx="4" fill="#ddd" />
            <rect x="125" y="100" width="10" height="10" fill="#aaa" />
            <rect x="140" y="100" width="10" height="10" fill="#aaa" />
            <rect x="125" y="115" width="10" height="10" fill="#aaa" />
            <rect x="140" y="115" width="10" height="10" fill="#aaa" />

            {/* Crane tower */}
            <rect x="40" y="40" width="12" height="140" fill="url(#g3)" />

            {/* Crane arm */}
            <rect x="40" y="40" width="110" height="8" fill={mainColor} />

            {/* Hook line */}
            <line
              x1="130"
              y1="48"
              x2="130"
              y2={animate ? 115 : 130}
              stroke="#333"
              strokeWidth="2"
            />

            {/* Hook */}
            <path d="M125 130 Q130 145 135 130" fill="none" stroke="#333" strokeWidth="2" />

            {/* Load */}
            <rect x="115" y={animate ? 115 : 130} width="30" height="20" rx="3" fill={mainColor} />
          </svg>
        </Box>
      </Box>
    </Box>
  );
}
